import {
  getChunkUpdateRecoveryState,
  retryStaleChunkRecovery,
  subscribeToChunkUpdateRecovery,
} from '@shared/utils/chunkUpdateRecovery';
import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

export const ChunkUpdateRecoveryOverlay = () => {
  const state = useSyncExternalStore(
    subscribeToChunkUpdateRecovery,
    getChunkUpdateRecoveryState,
    getChunkUpdateRecoveryState,
  );
  const { t } = useTranslation();

  if (state === 'idle') return null;

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-base-100 p-6"
      role={state === 'failed' ? 'alert' : 'status'}
      aria-live="assertive"
    >
      <section className="card w-full max-w-md bg-base-200 shadow-xl">
        <div className="card-body items-center text-center">
          {state === 'updating' ? (
            <>
              <span
                className="loading loading-spinner loading-lg text-primary"
                aria-hidden="true"
              />
              <h1 className="card-title">{t('serviceWorker.staleUpdating')}</h1>
              <p>{t('serviceWorker.staleUpdatingDescription')}</p>
            </>
          ) : (
            <>
              <h1 className="card-title">{t('serviceWorker.staleUpdateFailed')}</h1>
              <p>{t('serviceWorker.staleUpdateFailedDescription')}</p>
              <button
                className="btn btn-primary mt-2"
                onClick={() => void retryStaleChunkRecovery()}
              >
                {t('serviceWorker.retry')}
              </button>
            </>
          )}
        </div>
      </section>
    </div>
  );
};
